import styled, { css } from 'styled-components';

export const ButtonHeight = '56px';
export const ButtonHeightSmall = '39px';
export const ButtonWidth = '251px';
export const ButtonBorderWidth = '1px';
export const ButtonBorderStyle = 'solid';

export const buttonCss = css`
  color: rgba(0, 0, 0, 0.87);
  padding: 8px 16px;
  min-width: 88px;
  font-size: 14px;
  box-sizing: border-box;
  min-height: 36px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  line-height: 1.4em;
  font-weight: bold;
  text-transform: uppercase;
  color: inherit;
  cursor: pointer;
  margin: 0;
  border: 0;
  display: inline-flex;
  padding: 0;
  outline: none;
  position: relative;
  user-select: none;
  align-items: center;
  border-radius: 0;
  vertical-align: middle;
  justify-content: center;
  -moz-appearance: none;
  text-decoration: none;
  background-color: transparent;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  border-radius: 2px;
  cursor: ${props => props.disabled && 'default'};
  pointer-events: ${props => props.disabled && 'none'};
  background-color: ${props => props.disabled && 'rgba(0, 0, 0, 0.20)'};
  font-family: 'Brandon Text';
`;

const ButtonBase = styled.button`
  ${buttonCss};
`;

export default ButtonBase;
